import { useState } from 'react';

export default function ProgressRing({ progress, size = 180, strokeWidth = 12 }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;
  const isComplete = progress >= 100;

  return (
    <div
      className={`relative grid place-items-center rounded-2xl bg-[#111827] border p-6 ${
        isComplete
          ? 'border-[rgba(0,255,163,0.4)] rn-progress-complete'
          : 'border-[rgba(0,255,163,0.15)]'
      }`}
      data-testid="client-progress-ring"
    >
      <svg width={size} height={size} className="-rotate-90">
        {/* Background circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(255,255,255,0.08)"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={isComplete ? '#00FFA3' : '#00FFA3'}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.8s ease-out' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className={`font-display text-4xl font-bold tabular-nums ${
            isComplete ? 'text-[var(--rn-green)]' : 'text-white'
          }`}
          data-testid="client-progress-percent"
        >
          {progress}%
        </span>
        <span className="text-xs text-white/50 mt-1">Progresso</span>
      </div>
    </div>
  );
}
